module.exports = __webpack_public_path__ + "28b67065/img/verified-icon.f93bbc14.svg";